export const SUB_CATEGORY_GROUP_PREFIX = "SubCategoryGroup";

export const SUB_CATEGORY_GROUP_CLASSES = {
  item: `${SUB_CATEGORY_GROUP_PREFIX}-item`,
};
